import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  setItem(key: string, value): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.log(error);
    }
  }

  getItem(key: string) {
    try {
      var value = localStorage.getItem(key) || undefined;
      if (value && value!='undefined') {
        return JSON.parse(value);
      }
      return null;
    } catch (error) {
      console.log(error);
    }
  }

  deleteItem(key: string) {
    localStorage.removeItem(key);
  }

  clear() {
    localStorage.clear();
  }

  // Per-organization session storage. Lets a browser hold independent sessions for
  // multiple organizations at once (each keyed by organization_id) without one org's
  // login overwriting another's, while the "active org" pointer below is tab-scoped
  // (sessionStorage) so it can never leak across tabs/windows.
  private static readonly ORG_SESSIONS_KEY = 'bb_org_sessions';
  private static readonly ACTIVE_ORG_KEY = 'bb_active_org_id';

  setOrgSession(orgId: string | number, session: any): void {
    if (orgId === undefined || orgId === null) return;
    const sessions = this.getAllOrgSessions();
    sessions[String(orgId)] = session;
    this.setItem(StorageService.ORG_SESSIONS_KEY, sessions);
  }

  getOrgSession(orgId: string | number): any {
    if (orgId === undefined || orgId === null) return undefined;
    const sessions = this.getAllOrgSessions();
    return sessions[String(orgId)];
  }

  removeOrgSession(orgId: string | number): void {
    if (orgId === undefined || orgId === null) return;
    const sessions = this.getAllOrgSessions();
    delete sessions[String(orgId)];
    this.setItem(StorageService.ORG_SESSIONS_KEY, sessions);
  }

  getAllOrgSessions(): { [orgId: string]: any } {
    return this.getItem(StorageService.ORG_SESSIONS_KEY) || {};
  }

  setActiveOrgId(orgId: string | number): void {
    if (orgId === undefined || orgId === null) return;
    try {
      sessionStorage.setItem(StorageService.ACTIVE_ORG_KEY, String(orgId));
    } catch (error) {
      console.log(error);
    }
  }

  getActiveOrgId(): string | undefined {
    try {
      return sessionStorage.getItem(StorageService.ACTIVE_ORG_KEY) || undefined;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  // Tab-scoped, once-per-session flag: has ChannelWebpageGuard already offered this org's
  // authenticated fan a redirect to their preferred group on a plain (no-group) URL? Prevents
  // re-checking/redirecting on every subsequent direct visit within the same tab session, so a
  // fan who deliberately navigates back to network level afterward isn't bounced back again.
  private static readonly GROUP_REDIRECT_OFFERED_PREFIX = 'bb_group_redirect_offered_';

  hasOfferedGroupRedirect(orgId: string | number): boolean {
    if (orgId === undefined || orgId === null) return false;
    try {
      return sessionStorage.getItem(StorageService.GROUP_REDIRECT_OFFERED_PREFIX + orgId) === '1';
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  markGroupRedirectOffered(orgId: string | number): void {
    if (orgId === undefined || orgId === null) return;
    try {
      sessionStorage.setItem(StorageService.GROUP_REDIRECT_OFFERED_PREFIX + orgId, '1');
    } catch (error) {
      console.log(error);
    }
  }

}